import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

export interface IDmcTourMeetingPointParams {
  name: string
  location: string
  latitude: string | null
  longitude: string | null
  memo: string
}

export interface IDmcTourRankFeeParams {
  agent_rank_id: number
  amount: string
}

// ツアー情報(所要時間ごとの全Postに同じ内容を適用する)
export interface IDmcTourParams {
  short_name: string
  post_type: 'private' | 'group'
  // 貸切(グループツアーのみ)
  exclusive: boolean
  area_id: string
  tour_group_max_attendees: string
  language_ids: number[]
  title: string
  guide_meeting_time_offset: string
  post_cost: Record<string, number>
  post_rank_fees: IDmcTourRankFeeParams[]
  meeting_points: IDmcTourMeetingPointParams[]
  post_tour_skill: { tour_skill_id: string; level: string }
}

// ゲスト情報(1グループ = 1件のOTA予約)
export interface IDmcTourGuestParams {
  channel_manager: string
  seller: string
  tour_date: string
  tour_start_at: string
  customer_last_name: string
  customer_first_name: string
  customer_email: string
  customer_phone: string
  num_of_adults: string
  num_of_children: string
  num_of_infants: string
  other_requests: string
  duration: string
}

// ツアー情報画面は tour のみ、ゲスト情報画面は guests のみを送る
export interface IDmcTourSaveParams {
  tour?: IDmcTourParams
  guests?: IDmcTourGuestParams[]
}

class DmcTourService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async create(params: IDmcTourSaveParams) {
    const { data } = await this.httpClient.post('/agent/api/dmc_tours', params)
    return data
  }

  public async update(id: number, params: IDmcTourSaveParams) {
    const { data } = await this.httpClient.patch(`/agent/api/dmc_tours/${id}`, params)
    return data
  }
}

export default DmcTourService
